import f, { ODataFilterBuilder } from 'odata-filter-builder';
import { escape, isEmpty, ODataUtils } from '../../../utils';
import { RoleTypeSearchParams } from './types';

export const createRoleTypeFilter = ({ name, companyId }: Partial<RoleTypeSearchParams> = {}) => {
    const filterRules: ODataFilterBuilder[] = [];

    if (!isEmpty(name)) {
        filterRules.push(f().contains('name', escape(name!)));
    }

    if (!isEmpty(companyId)) {
        filterRules.push(f().eq('companyId', +companyId!));
    }

    return filterRules.length ? ODataUtils.andConditions(filterRules).toString() : undefined;
};
